import React from 'react';

const ReturnPolicy = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="card p-6">
        <h1 className="text-3xl font-bold mb-4">Return & Exchange Policy</h1>
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          We want you to love your purchase. If something isn’t right, here’s how returns and
          exchanges work at TRENDZ.
        </p>

        <div className="space-y-6">
          <section>
            <h2 className="text-xl font-semibold mb-2">Eligibility</h2>
            <ul className="list-disc list-inside text-gray-600 dark:text-gray-400 space-y-1">
              <li>Return/Exchange requests must be made within 7 days of delivery.</li>
              <li>Items must be unused, unwashed, and in original packaging with tags.</li>
              <li>Items marked as “final sale” may not be eligible for return.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">Non‑Returnable Items</h2>
            <ul className="list-disc list-inside text-gray-600 dark:text-gray-400 space-y-1">
              <li>Used or damaged items (not due to a shipping issue)</li>
              <li>Items without original tags/packaging</li>
              <li>Customized/personalized items (if applicable)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">How to Request a Return/Exchange</h2>
            <ol className="list-decimal list-inside text-gray-600 dark:text-gray-400 space-y-1">
              <li>Contact us with your Order # and the reason for return/exchange.</li>
              <li>Share photos if the item is defective or incorrect.</li>
              <li>We will guide you through pickup/drop-off steps.</li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">Refunds</h2>
            <p className="text-gray-600 dark:text-gray-400">
              Once we receive and inspect the item, we will process the refund/exchange. Refund
              timing depends on your payment method and bank/wallet processing time.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">Need Help?</h2>
            <p className="text-gray-600 dark:text-gray-400">
              Contact us at <strong>trendz.supp0rt@gmail.com</strong> or <strong>03708426610</strong>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default ReturnPolicy;

